import { useDrop } from "react-dnd";
type DroppableZoneProps<T = unknown> = {
  dndType: string;
  onDrop: (item: T) => void;
  children: React.ReactNode;
};

/* droppable zone for cross-section drag-drop (included <-> excluded)
expands when hovering a dragged item to provide clear drop target feedback
delegates to nested row drop handlers when available
*/
export const DroppableZone = <T extends { id: number }>({
  dndType,
  onDrop,
  children,
}: DroppableZoneProps<T>) => {
  const [{ isOver }, drop] = useDrop<T, void, { isOver: boolean }>(() => ({
    accept: dndType,
    drop: (item, monitor) => {
      // only handle drop if a nested drop target (row) hasn't already handled it
      if (!monitor.didDrop()) {
        onDrop(item);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      className={`droppable-zone ${isOver ? "is-over" : ""}`}
      style={{
        minHeight: isOver ? "100px" : "50px",
        transition: "min-height 0.2s ease",
      }}
    >
      {children}
    </div>
  );
};
